import { render } from "./ktTopicInfo.vue?vue&type=template&id=406b8871&scoped=true"
import script from "./ktTopicInfo.vue?vue&type=script&lang=js"
export * from "./ktTopicInfo.vue?vue&type=script&lang=js"

import "./ktTopicInfo.vue?vue&type=style&index=0&id=406b8871&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406b8871"]])

export default __exports__